const API_BASE_URL = process.env?.REACT_APP_API_BASE_URL || '';
const STRIPE_KEY = process.env?.REACT_APP_STRIPE_KEY || '';
const STRIPE_SECRET = process.env?.REACT_APP_STRIPE_SECRET || '';

const COMPANY_CONTACT_NUMBER = '+81-6-6379-3026';
const COMPANY_SUPPORT_EMAIL = 'support@yunige.info';
const COMPANY_SERVICE_EMAIL = 'service@yunige.info';

export { API_BASE_URL, STRIPE_KEY, STRIPE_SECRET, COMPANY_CONTACT_NUMBER, COMPANY_SERVICE_EMAIL, COMPANY_SUPPORT_EMAIL };